import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import API_BASE_URL from "../../config";
import "./AddPop.css";

const AddPopForm = ({ editData }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [primaryPops, setPrimaryPops] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [popData, setPopData] = useState({
    id: editData?.id || "",
    pop_name: editData?.pop_name || "",
    address: editData?.address || "",
    pop_type: editData?.pop_type || "",
    parent_pop: editData?.parent_pop || "",
    secondary_parent: editData?.secondary_parent || "",
    contact_person: editData?.contact_person || "",
    mobile: editData?.mobile || "",
    email: editData?.email || "",
    notes: editData?.notes || ""
  });

  useEffect(() => {
    const fetchPops = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/info-manage/pops`);
        const json = await res.json();
        if (json.success) {
          setPrimaryPops(json.data.filter(p => p.pop_type === "Primary"));
        }
      } catch (err) { console.error(err); }
    };
    fetchPops();
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === "pop_type") {
      setPopData(prev => ({ ...prev, pop_type: value, parent_pop: "", secondary_parent: "" }));
    } else {
      setPopData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const url = editData
        ? `${API_BASE_URL}/info-manage/pops/edit/${editData.id}`
        : `${API_BASE_URL}/info-manage/pops/add`;
      const method = editData ? "PUT" : "POST";
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(popData)
      });
      const result = await res.json();
      if (result.success) {
        setShowModal(true);
      } else {
        alert(result.error || "Something went wrong");
      }
    } catch (err) {
      alert("Error connecting to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-pop-container">
      <div className="add-pop-card">
        <h2 className="add-pop-form-title">{editData ? "Edit POP Info" : "Add POP Info"}</h2>

        <form className="add-pop-form" onSubmit={handleSubmit}>
          <div className="add-pop-grid-row">
            <div className="add-pop-input-group">
              <label>POP ID</label>
              <input
                type="text" name="id" value={popData.id}
                onChange={handleChange} required
                placeholder="Ex: MMR25030007"
                readOnly={!!editData}
              />
            </div>
            <div className="add-pop-input-group">
              <label>POP Name</label>
              <input
                type="text" name="pop_name" value={popData.pop_name}
                onChange={handleChange} required placeholder="Enter Name"
              />
            </div>
          </div>

          <div className="add-pop-input-group">
            <label>Address</label>
            <input
              type="text" name="address" value={popData.address}
              onChange={handleChange} required placeholder="Location Address"
            />
          </div>

          <div className="input-group-pop">
            <label>Type</label>
            <select name="pop_type" value={popData.pop_type} onChange={handleChange} required>
              <option value="">Select</option>
              <option value="Primary">Primary</option>
              <option value="Secondary">Secondary</option>
              <option value="Others">Others</option>
            </select>
          </div>

          {["Secondary", "Others"].includes(popData.pop_type) && (
            <div className="input-group-pop">
              <label>Parent POP</label>
              <select name="parent_pop" value={popData.parent_pop} onChange={handleChange} required>
                <option value="">Select Primary POP</option>
                {primaryPops.map(pop => (
                  <option key={pop.id} value={pop.id}>{pop.pop_name}</option>
                ))}
              </select>
            </div>
          )}

          <div className="add-pop-grid-row">
            <div className="add-pop-input-group">
              <label>Contact Person</label>
              <input
                type="text" name="contact_person" value={popData.contact_person}
                onChange={handleChange} placeholder="Name"
              />
            </div>
            <div className="add-pop-input-group">
              <label>Mobile</label>
              <input
                type="text" name="mobile" value={popData.mobile}
                onChange={handleChange} placeholder="01XXX-XXXXXX"
              />
            </div>
          </div>

          <div className="add-pop-input-group">
            <label>Email</label>
            <input
              type="email" name="email" value={popData.email}
              onChange={handleChange} placeholder="email@example.com"
            />
          </div>

          <div className="add-pop-input-group">
            <label>Notes</label>
            <textarea
              name="notes" value={popData.notes}
              onChange={handleChange} rows="2"
              placeholder="Additional details..."
            />
          </div>

          <div className="add-pop-button-group">
            <button type="button" className="add-pop-btn-cancel" onClick={() => navigate(-1)}>
              Cancel
            </button>
            <button type="submit" className="add-pop-btn-submit" disabled={loading}>
              {loading ? "Saving..." : (editData ? "Update" : "Submit")}
            </button>
          </div>
        </form>
      </div>

      {showModal && (
        <div className="add-pop-modal-overlay">
          <div className="add-pop-modal-box">
            <h3>✅ Successful!</h3>
            <p>POP information saved successfully.</p>
            <button
              onClick={() => navigate("/info-manage/pop-list")}
              className="add-pop-btn-submit"
              style={{ width: "100%", marginTop: "10px" }}
            >
              Go to POP List
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddPopForm;
